import { ParameterCodeDataPolicy } from "constants/common/ParameterCodeDataPolicy"

export const ParameterMaintenanceConstant = {
    CATEGORY: "Support",
    TITLE: "Parameter",
    OPERATING_COMPANY: "Operating Company",
    OPERATING_UNIT: "Operating Unit",
    PARAMETER_CODE: "Parameter Code",
    PARAMETER_DESC: "Parameter Desc.",
    ACTIVE_IND: 'Active Ind.',

    Detail: {
        TITLE: "Parameter Detail",
        SUB_TITLE: "Parameter Sub Detail",
        PARAMETER_DETAIL_CODE: "Parameter Detail Code",
        PARAMETER_DETAIL_DESC: "Parameter Detail Desc."
    }
}

export const SaptNoDtlParameterCodeData = [
    ParameterCodeDataPolicy.INV_CUTOFF_DATE,
    ParameterCodeDataPolicy.HALF_DAY_CUTOFF_TIME,
    ParameterCodeDataPolicy.HANDLE_SHORTSEA_AS,
    ParameterCodeDataPolicy.HANDLING_CHARGE,
    ParameterCodeDataPolicy.DEPOSIT_BANK_CODE,
    ParameterCodeDataPolicy.LET_PASS_AC_THRESHOLD,
    ParameterCodeDataPolicy.DEFAULT_INTERCOMPANY_CODE,
    ParameterCodeDataPolicy.GATE_PASS_GRACE_HOUR,
    ParameterCodeDataPolicy.DOCUMENT_CHARGE_RATE,
    ParameterCodeDataPolicy.DEFAULT_COUNTRY,
    ParameterCodeDataPolicy.DEFAULT_LOC_FOR_DOC_SOFTCOPY,
    ParameterCodeDataPolicy.DEFAULT_PRINTER_DOC_PREV,
    ParameterCodeDataPolicy.REFUND_THRESHOLD_AMT,
    ParameterCodeDataPolicy.DUMMY_COMPANY,
    ParameterCodeDataPolicy.COLL_INV_REC_COPIES,
    ParameterCodeDataPolicy.BANK_ADVISE_SIGNATURE_COMPANY,
] as const

export const OictNoDtlParameterCodeData = [
    ParameterCodeDataPolicy.INV_CUTOFF_DATE,
    ParameterCodeDataPolicy.HALF_DAY_CUTOFF_TIME,
    ParameterCodeDataPolicy.HANDLE_SHORTSEA_AS,
    ParameterCodeDataPolicy.HANDLING_CHARGE,
    ParameterCodeDataPolicy.DEPOSIT_BANK_CODE,
    ParameterCodeDataPolicy.LET_PASS_AC_THRESHOLD,
    ParameterCodeDataPolicy.DEFAULT_INTERCOMPANY_CODE,
    ParameterCodeDataPolicy.GATE_PASS_GRACE_HOUR,
    ParameterCodeDataPolicy.BILLING_TYPE_INBOUND_NON_CY,
    ParameterCodeDataPolicy.BILLING_TYPE_OUTBOUND_NON_CY,
    ParameterCodeDataPolicy.DEFAULT_OPERATING_TML,
    ParameterCodeDataPolicy.DOCUMENT_CHARGE_RATE,
    ParameterCodeDataPolicy.DOC_BANK_DETAILS,
    ParameterCodeDataPolicy.DOC_ACCOUNT_NO,
    ParameterCodeDataPolicy.DOC_SORT_CODE,
    ParameterCodeDataPolicy.DOC_IBAN_NO,
    ParameterCodeDataPolicy.DOC_SWIFT_CODE,
    ParameterCodeDataPolicy.DOC_TAX_STATEMENT,
    ParameterCodeDataPolicy.COUNTER_SUR_LIST_FOR_DG_OOG,
] as const


// export const SaptThirdDtlParameterCodeData = [
//     ParameterCodeDataPolicy.RAILWAY_SETTING,
//     ParameterCodeDataPolicy.CREDIT_NOTE_NATURE,
//     ParameterCodeDataPolicy.SERVICE_ORDER_CODE,
//     ParameterCodeDataPolicy.DOC_USER_PRINTER,
//     ParameterCodeDataPolicy.DOC_USER_PRINTER_API,
// ] as const

// export const OictThirdDtlParameterCodeData = [
//     ParameterCodeDataPolicy.RAILWAY_SETTING,
//     ParameterCodeDataPolicy.CREDIT_NOTE_NATURE,
//     ParameterCodeDataPolicy.SERVICE_ORDER_CODE,
//     ParameterCodeDataPolicy.FISCAL_PRINTER,
//     ParameterCodeDataPolicy.DOC_USER_PRINTER,
//     ParameterCodeDataPolicy.DOC_USER_PRINTER_API,
// ] as const